import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { createPaginatedSchema, entityWithTitleSchema } from '../types';

export const createGetGamesCashierQuery = () =>
	createAuthQuery({
		request: {
			method: 'GET',
			url: '/games/available/list',
		},
		response: {
			contract: zodContract(createPaginatedSchema(entityWithTitleSchema)),
		},
	});
